import Rebase from 're-base';
import * as firebase from "firebase"

const config = {
    apiKey: "AIzaSyBanP0AphnSqR-8MZcSTQDC4pAiGw8kGzQ",
    authDomain: "task-8ae14.firebaseapp.com",
    databaseURL: "https://task-8ae14.firebaseio.com",
    projectId: "task-8ae14",
    storageBucket: "task-8ae14.appspot.com",
    messagingSenderId: "50005033503"
  };
const app = firebase.initializeApp(config);
const base = Rebase.createClass(app.database());

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const auth = app.auth();
const isAuthenticated = () => {
  return !!auth.currentUser;
}
export { base,auth, firebase,googleAuthProvider,isAuthenticated};


// WEBPACK FOOTER //
// ./src/base.js